import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Footer as HTMLFooter } from '@expo/html-elements';
import {
  Container,
  HStack,
  theme,
  useContainerSpacing,
  useResponsive,
} from '@sweetgreen/garnish';

import type { useOrganizationLinksFooterContentfulData } from '../hooks';
import { OrganizationLinksFooterCopyright } from './OrganizationLinksFooterCopyright';
import { OrganizationLinksFooterSection } from './OrganizationLinksFooterSection';

export const OrganizationLinksFooterContent = (props: ContentProps) => {
  const { contentfulFooter } = props;

  const containerSpacing = useContainerSpacing();
  const { currentBreakpoint, match } = useResponsive();
  const { isSM } = currentBreakpoint;

  const itemsPerRow = match([1, 2, contentfulFooter.sections.length + 2]);
  const contentStyles = match([undefined, styles.contentMarginSM, undefined]);
  const footerStyles = [styles.footer, { paddingVertical: containerSpacing }];

  return (
    <HTMLFooter style={footerStyles}>
      <Container style={styles.containerFlexDirection}>
        <HStack itemsPerRow={itemsPerRow} style={contentStyles}>
          {contentfulFooter.sections.map((section) => (
            <OrganizationLinksFooterSection
              key={section.name}
              section={section}
            />
          ))}
          {!isSM ? <EmptyColumn /> : null}
          {!isSM ? <OrganizationLinksFooterCopyright /> : null}
        </HStack>
        {isSM ? <OrganizationLinksFooterCopyright /> : null}
      </Container>
    </HTMLFooter>
  );
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

const EmptyColumn = View; // For Layouting with ItemsPerRow.

// ─── Types ───────────────────────────────────────────────────────────────────

type ContentProps = {
  readonly contentfulFooter: ReturnType<
    typeof useOrganizationLinksFooterContentfulData
  >['contentfulFooter'];
};

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  footer: {
    marginTop: 'auto',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.SKY,
  },
  containerFlexDirection: {
    flexDirection: 'row',
  },
  contentMarginSM: {
    marginRight: '33%',
  },
});
